<template>
  <div class="page-bg page">
    <SubHeader :title="headerTitle" :isBack="true" :isBg="false"></SubHeader>
    <div class="main">
      <div class="page-content">
        <div class="details-address" v-if="address.length > 0">
          <div class="item-header" @click="$router.push('/user/address/')">
            <div class="item-img"><img :src="userInfo.avatar" /></div>
            <div class="item-info">
              <div class="title">
                <div class="name-phone">
                  {{ addressInfo.name }} {{ addressInfo.phone }}
                </div>
                <div
                  class="set"
                  v-show="parseInt(addressInfo.isdefault) === 1"
                ></div>
              </div>
              <div class="desc">
                {{
                  addressInfo.province +
                  addressInfo.city +
                  addressInfo.county +
                  addressInfo.address
                }}
              </div>
            </div>
            <div>
              <van-icon name="arrow" />
            </div>
          </div>
        </div>
        <div class="details-address" v-else>
          <div class="item-header" @click="$router.push('/user/address/')">
            <div class="item-info"></div>
            <div>点击选择地址 <van-icon name="arrow" /></div>
          </div>
        </div>
        <div class="details-goods">
          <div
            class="preview-img"
            :style="{ backgroundImage: 'url(' + info.img + ')' }"
          ></div>
          <div class="item-info">
            <div class="title">繁花相送</div>
            <div class="author">冷峻</div>
          </div>
        </div>
        <div class="details-info">
          
          <div class="item">
            <span class="title">出售方</span>
            <span class="text">若森</span>
          </div>
          <div class="item">
            <span class="title">金额</span>
            <span class="text">￥30.00</span>
          </div>
        </div>
        <div class="details-pay">
          <div class="pay-title">支付方式</div>
          <div class="pay-way">
            <div
              class="pay-way-item"
              @click="paySelect('wechat')"
              :class="{ active: pay === 'wechat' }"
            >
              微信
            </div>
            <div
              class="pay-way-item"
              @click="paySelect('alipay')"
              :class="{ active: pay === 'alipay' }"
            >
              支付宝
            </div>
          </div>
        </div>

        <div class="details-btn">
          <div class="btn">返回详情</div>
          <div class="btn yellow">立即支付</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SubHeader from "../../../components/sub_header";
import Vue from "vue";
import { mapActions, mapMutations, mapState } from "vuex";
import { Icon, Toast } from "vant";

Vue.use(Icon);


export default {
  name: "goods-order",
  data() {
    return {
      info: {
        status: 0,
        img: require("../../../assets/images/home/goods/pic.png"),
      },

      num: 0,
      addressInfo: {},
      pay: "wechat",
    };
  },
  components: {
    SubHeader,
  },
  computed: {
    ...mapState({
      address: (state) => state.address.address,
      userInfo: (state) => state.user.userInfo,
    }),
  },
  mounted() {},

  created() {
    // communityIsShow

    this.$store.commit("index/SET_COMMUNITY_IS_SHOW", {
      communityIsShow: false,
    });

    document.title = this.$route.meta.title;
    this.headerTitle = this.$route.meta.title;

    let toastLoading = Toast.loading({
      duration: 0, // 持续展示 toast
      forbidClick: true,
    });
    toastLoading.clear();
    let addressInfo = {};
    if (this.address.length > 0) {
      for (let i in this.address) {
        if (parseInt(this.address[i].isdefault) === 1) {
          addressInfo = this.address[i];
        }
      }
      this.addressInfo = addressInfo;
    } else {
      this.getAddress({
        success: (res) => {
          console.log(res);
          toastLoading.clear();
          if (res.status === 1) {
            for (let i in res.address_list) {
              if (parseInt(res.address_list[i].isdefault) === 1) {
                addressInfo = res.address_list[i];
              }
            }
            this.addressInfo = addressInfo;
          }
        },
      });
    }

    // let vm = this;
    // if(!parseInt(this.gid)){
    //     Toast.fail('参数错误');
    //     setTimeout(()=>{
    //         Toast.clear();
    //         this.$router.go(-1);
    //     },600)
    //     return false;
    // }

    // let toastLoading = Toast.loading({
    //     duration: 0, // 持续展示 toast
    //     forbidClick: true,
    //     message: '正在加载...',
    // });

    // this.getDetails({id:this.gid,success:(res)=>{
    //     toastLoading.clear();

    //     if(res.status === 1){

    //         vm.isShow = true;

    //     } else {

    //         Toast.fail(res.message);
    //         setTimeout(()=>{
    //             Toast.clear();
    //             this.$router.go(-1);
    //         },600)

    //     }
    // }});
  },
  methods: {
    ...mapMutations({
      SET_COMMUNITY_IS_SHOW: "index/SET_COMMUNITY_IS_SHOW",
    }),
    ...mapActions({
      getDetails: "goods/getDetails",
      getAddress: "address/getAddress",
    }),

    paySelect(val) {
      this.pay = val;
    },
  },

  beforeDestroy() {
    // this.$store.commit("index/SET_COMMUNITY_IS_SHOW",{communityIsShow:true});
    this.SET_COMMUNITY_IS_SHOW({ communityIsShow: true });
  },
  destroy() {
    this.SET_COMMUNITY_IS_SHOW({ communityIsShow: true });
  },
};
</script>

<style lang="scss" scoped>
.page {
  width: 100%;
  background-size: cover;
  // padding-bottom: 1.2rem;
  box-sizing: border-box;
  height: 100vh;
}
.main {
  overflow: hidden;
  box-sizing: border-box;
  height: calc(100vh - 1.45rem);
  position: relative;
}
.page-content {
  position: relative;
  height: 100%;
  box-sizing: border-box;
  padding: 0 0.4rem 2rem;
  overflow-y: auto;
}
.details-icon {
  text-align: center;
  margin-top: 0.43rem;
  img {
    width: 1.11rem;
    height: 1.11rem;
  }
}

.details-goods {
  margin-top: 0.6rem;
  overflow: hidden;
  background-image: linear-gradient(left, #cfcecb, #afaca8);
  border-radius: 0.15rem;
  overflow: hidden;
  display: flex;
  // align-items: center;
  .preview-img {
    width: 2.4rem;
    height: 2.4rem;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    border-radius: 0.15rem;
    border: 0.02rem solid #fff;
  }
  .item-info {
    flex: 1;
    padding: 0.4rem;
    color: #404040;
    line-height: 1.6;
    .title {
      font-size: 0.3rem;
    }
    .author {
      font-size: 0.25rem;
      color: #505050;
      margin: 0.3rem 0 0;
    }
  }
}

.details-info {
  padding: 0.4rem;

  .item {
    overflow: hidden;
    font-size: 0.26rem;
    color: #505050;
    line-height: 1.6;
    margin: 0.2rem 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .title {
      float: left;
    }
    .text {
      float: right;
    }
  }
}

.details-btn {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 0.25rem;
  margin-top: 0.6rem;
  .btn {
    font-size: 0.3rem;
    width: 2.42rem;
    height: 0.63rem;
    text-align: center;
    border-radius: 0.63rem;
    background-image: linear-gradient(left, #b7b7b7, #7b7b7b);
    line-height: 0.63rem;

    &.yellow {
      background-image: linear-gradient(left, #f7c378, #d88f20);
    }
  }
}

.details-address {
  background: url(../../../assets/images/user/set/bg.png) repeat-y left top;
  background-size: 100% auto;
  margin: 0 -0.4rem;
  .item-header {
    padding: 0.2rem 0.5rem;
    display: flex;
    align-items: center;
    .item-img {
      width: 0.95rem;
      height: 0.95rem;
      box-sizing: border-box;
      border-radius: 50%;
      overflow: hidden;
      border: 2px solid #2b2b2a;
      margin-right: 0.23rem;
      font-size: 0;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .item-info {
      flex: 1;

      .title {
        font-size: 0.3rem;
        color: #3d3d3d;
        display: flex;
        align-items: center;
        line-height: 1;

        .set {
          margin-left: 0.16rem;
          width: 0.58rem;
          height: 0.25rem;
          background: url(../../../assets/images/user/set/ic2.png) no-repeat
            center;
          background-size: 100%;
        }
      }
      .desc {
        line-height: 1.2;
        margin-top: 0.2rem;
        color: #818181;
        font-size: 0.24rem;
      }
    }
    .modify-icon {
      width: 0.35rem;
      height: 0.45rem;
      background: url(../../../assets/images/user/set/ic3.png) no-repeat center;
      background-size: 100%;
    }
  }
}

.details-pay {
  .pay-title {
    font-size: 0.28rem;
    color: #505050;
  }
  .pay-way {
    .pay-way-item {
      background: url(../../../assets/images/user/set/bg.png) repeat-y left top;
      background-size: 100% auto;
      color: #3d3d3d;
      font-size: 0.26rem;
      margin-top: 0.2rem;
      padding: 0.2rem 0.2rem;
      position: relative;
      border-radius: 0.1rem;

      &::after {
        content: "";
        position: absolute;
        right: 0.2rem;
        top: 0;
        width: 0.33rem;
        height: 100%;
        background-image: url(../../../assets/images/user/set/ic1.png);
        background-size: auto 0.3rem;
        background-position: center;
        background-repeat: no-repeat;
      }
      &.active {
        // border: 1px solid #ff8a00;
        color: #ff8a00;
        &::after {
          background-image: url(../../../assets/images/user/set/ic1-on.png);
        }
      }
    }
  }
}
</style>

